import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/pro-light-svg-icons';
import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Box, Button, IconButton } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

const ArrowNavigationStyles = styled.div`
  display: inline-flex;
  align-self: flex-end;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
  }

  .cnt-box {
    min-width: 36px;
    text-align: center;
  }
`;

const Year = styled(Button)`
  &:hover {
    background-color: transparent !important;
    cursor: auto;
  }
`;

interface YearQuarterNavigationProps {
  hasWeekView?: boolean;
}

export default function YearQuarterNavigation({
  hasWeekView = true
}: YearQuarterNavigationProps) {
  const { t } = useTranslation('common');
  const {
    isViewPerWeek,
    toggleView,
    year,
    quarter,
    onNavigate,
    onNavigateYear
  } = useYearQuarterNavigation();

  return (
    <ArrowNavigationStyles className="arrow-navigation">
      <IconButton
        onClick={() =>
          hasWeekView ? onNavigate('prev') : onNavigateYear('prev')
        }
        color="primary"
        size="small"
      >
        <FontAwesomeSvgIcon icon={faChevronLeft} fontSize="small" />
      </IconButton>
      <Box>
        {hasWeekView ? (
          <Button variant="text" color="primary" onClick={toggleView}>
            {isViewPerWeek ? `${year} - ${t('quarter')} ${quarter}` : year}
          </Button>
        ) : (
          <Year
            variant="text"
            color="primary"
            aria-disabled={true}
            disableFocusRipple={true}
            disableRipple={true}
          >
            {year}
          </Year>
        )}
      </Box>
      <IconButton
        onClick={() =>
          hasWeekView ? onNavigate('next') : onNavigateYear('next')
        }
        color="primary"
        size="small"
      >
        <FontAwesomeSvgIcon icon={faChevronRight} fontSize="small" />
      </IconButton>
    </ArrowNavigationStyles>
  );
}
